module.exports = __webpack_public_path__ + "media/images/flags/eg-2ecaed2a529c7f847ec2cc68113aba43.svg";